<h1 class="page-title">Credential Maintenance</h1>
<span *ngIf="ccpEligible">
    <div *ngIf="ccpStatus && ccpStatus.reinstate">
        <p>
            Because your credential is expired less than 6 months, you have the option
      of entering the number of Category 1 CEUs indicated below and paying the
      required reinstatement fee. Your continuing education hours must be earned
      within the dates of {{ ccpBegins | date : "longDate" }} -
      {{ ccpEnds | date : "longDate" }}.
        </p>
        <p>
            <strong>
                If you do not enter CEUs and pay the reinstatement fee by
        {{ ccpGraceEnds | date : "longDate" }}
            </strong>
            , you must successfully complete the examination to reinstate your
      expired credential. Your credential will be reinstated when you
      successfully complete the examination. If you have more than one expired
      credential, you must pass all examinations to reinstate your expired
      credentials.
        </p>
    </div>
    <div
        *ngIf="ccpStatus.zoneStatus === 'GREEN'"
        style="color: green"
    >
        <p>
            <strong>
                Congratulations! You are not required to document CEUs due to your
      outstanding performance on assessments.
            </strong>
            To finish the recertification process, you must click on [Recertify Now] below.  
      The [Recertify Now] button will become active when you are within 6 months of your credential expiration date.
        </p>
    </div>

    <div *ngIf="ccpStatus && !ccpStatus.reinstate && !ccpAudit">
        <h2 class="heading--3">
            Options for maintaining credentials are below:
        </h2>

        <p>
            <strong>Option 1:</strong>
            Completion of Category 1 Continuing Education
      (CE) hours. You may use credits from the American Association for
      Respiratory Care Continuing Respiratory Care Education Program
      (AARC-CRCE®) to fulfill the NBRC Credential Maintenance Program
      requirements as well as any CE hours accepted by your state licensure
      board (if applicable).
        </p>
        <p *ngIf="ccpStatus && !ccpStatus.reinstate && !ccpAudit">
            CE course activity may be entered at any time prior to your credential
      expiration, but you must click on the [Recertify Now] button to complete
      your recertification. Use the Add Course or Import AARC Courses options
      below to document your CEUs.
        </p>
        <p>
            <button
                class="button button--alt"
                routerLink="/assessment/"
            >
                Go to Assessments
            </button>
        </p>
        <p>
            Please note, the number of CEUs listed below will not be final until you
      have completed your last assessment or 6 months prior to your expiration
      date.
        </p>
    </div>
    <!-- <div>
	<p>You may use credits from the American Association for Respiratory Care Continuing Respiratory Care Education Program (AARC-CRCE®) to 
			fulfill the NBRC Credential Maintenance Program requirements as well as any CE hours accepted by your state licensure board (if applicable). 
			<span *ngIf="!ccpAudit">Add/Import courses below.</span></p>
</div> -->
    <ng-template #cardLoading>
        <div class="ceu-card--loading">
            <div class="ceu-spinner"></div>
            Loading continuing education hours...
        </div>
    </ng-template>

    <div
        class="ceu-card"
        *ngIf="hoursAchieved; else cardLoading"
    >
        <div class="ceu-card__header">
            <div class="ceu-card__header-top">
                <div class="ceu-card__title">Continuing Education Hours</div>
                <div
                    class="ceu-zone"
                    *ngIf="ccpStatus && (ccpStatus.zoneStatus === 'GREEN' || ccpStatus.zoneStatus === 'YELLOW' || ccpStatus.zoneStatus === 'RED')"
                >
                    Practitioner CMP Assessment Zone:
                    <span
                        class="ceu-zone__badge"
                        [class.ceu-zone__badge--green]="ccpStatus.zoneStatus === 'GREEN'"
                        [class.ceu-zone__badge--yellow]="ccpStatus.zoneStatus === 'YELLOW'"
                        [class.ceu-zone__badge--red]="ccpStatus.zoneStatus === 'RED'"
                        [class.ceu-zone__badge--link]="ccpStatus.zoneStatus === 'GREEN' || ccpStatus.zoneStatus === 'YELLOW'"
                        [routerLink]="ccpStatus.zoneStatus === 'GREEN' || ccpStatus.zoneStatus === 'YELLOW' || ccpStatus.zoneStatus === 'RED'? '/assessment' : null"
                        [title]="ccpStatus.zoneStatus === 'GREEN' || ccpStatus.zoneStatus === 'YELLOW' || ccpStatus.zoneStatus === 'RED'? 'Go to Assessments' : null"
                    >
                        {{ ccpStatus.zoneStatus }}
                    </span>
                </div>
            </div>
            <div
                class="ceu-card__range"
                *ngIf="ccpBegins && ccpEnds"
            >
                {{ ccpBegins | date : "longDate" }} – {{ ccpEnds | date : "longDate" }}
            </div>
        </div>

        <div
            class="ceu-audit-notice"
            *ngIf="ccpAudit"
        >
            <i class="fa fa-exclamation-triangle"></i>
            Audit Due {{ ccpStatus.AuditDue | date : "M/d/yyyy" }}
        </div>

        <div class="ceu-hours">
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.greHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    General Hours
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.greHours, hoursAchieved?.greHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.greHours, hoursAchieved?.greHoursRequired, '#2ecc71')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.greHours, hoursAchieved?.greHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.greHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.greHoursRequired }}
                    </span>
                </ng-container>
            </div>
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.neoHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    Neonatal&#x2F;Pediatric
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.neoHours, hoursAchieved?.neoHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.neoHours, hoursAchieved?.neoHoursRequired, '#3498db')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.neoHours, hoursAchieved?.neoHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.neoHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.neoHoursRequired }}
                    </span>
                </ng-container>
            </div>
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.pftHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    Pulmonary Function
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.pftHours, hoursAchieved?.pftHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.pftHours, hoursAchieved?.pftHoursRequired, '#e05c9a')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.pftHours, hoursAchieved?.pftHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.pftHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.pftHoursRequired }}
                    </span>
                </ng-container>
            </div>
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.sdsHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    Sleep Disorder
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.sdsHours, hoursAchieved?.sdsHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.sdsHours, hoursAchieved?.sdsHoursRequired, '#f39c12')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.sdsHours, hoursAchieved?.sdsHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.sdsHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.sdsHoursRequired }}
                    </span>
                </ng-container>
            </div>
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.accsHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    Adult Critical Care
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.accsHours, hoursAchieved?.accsHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.accsHours, hoursAchieved?.accsHoursRequired, '#9b59b6')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.accsHours, hoursAchieved?.accsHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.accsHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.accsHoursRequired }}
                    </span>
                </ng-container>
            </div>
            <div
                class="ceu-hours__row"
                *ngIf="hoursAchieved?.aecHoursRequired > 0"
            >
                <span class="ceu-hours__label">
                    Asthma Educator
                    <i
                        class="fa fa-check-circle ceu-check"
                        *ngIf="ceuMet(hoursAchieved?.aecHours, hoursAchieved?.aecHoursRequired)"
                    ></i>
                </span>
                <ng-container>
                    <div class="ceu-bar">
                        <div
                            class="ceu-bar__fill"
                            [style.background]="ceuBarColor(hoursAchieved?.aecHours, hoursAchieved?.aecHoursRequired, '#29b6f6')"
                            [style.width.%]="ceuBarWidth(hoursAchieved?.aecHours, hoursAchieved?.aecHoursRequired)"
                        ></div>
                    </div>
                    <span class="ceu-hours__count">
                        {{ (hoursAchieved?.aecHours || 0) | number:'.0-2' }} / {{ hoursAchieved?.aecHoursRequired }}
                    </span>
                </ng-container>
            </div>
        </div>
    </div>
    <div
        *ngIf="!ccpAudit"
        class="button-list"
    >
        <button
            class="button button--alt"
            [disabled]="recertEligible === false"
            (click)="performRecertificationTask()"
        >
            Recertify Now
        </button>
        <button
            class="button button--alt"
            routerLink="/practitioner/credentials-maintenance/courses/add"
        >
            Add Course
        </button>
        <button
            class="button button--alt"
            title="Import CRCE records from AARC"
            (click)="openImportCourseForm()"
        >
            Import AARC Courses
        </button>
        <button
            class="button button--alt"
            (click)="generateCEReport()"
        >
            List of Courses
        </button>
    </div>
    <!-- <p style="color:red">Due to a system upgrade, Import AARC Courses is currently unavailable. We anticipate this service will be available Friday, June 24th. Please check back for updates.</p> -->

    <app-import-course
        *ngIf="importCourseFormVisible"
        (onImportCourse)="getCredentialsData()"
        (onCancelForm)="closeForm()"
    ></app-import-course>

    <p *ngIf="ccpStatus && ccpStatus.reinstate">
        You must click on the [Recertify Now] button to complete your
    recertification. The [Recertify Now] button will become active after you
    have entered the CE hours needed to recertify your credential(s).
    </p>
    <p *ngIf="ccpStatus && !ccpAudit && !ccpStatus.reinstate">
        The [Recertify Now] button will become active after you have entered the
    required number of CE hours and you are
        <u>
            within 6 months of your credential expiration date
        </u>
        .
    </p>
    <p *ngIf="ccpStatus && !ccpAudit && !ccpStatus.reinstate">
        Your continuing education hours must be within the dates of
    {{ ccpBegins | date : "longDate" }} - {{ ccpEnds | date : "longDate" }}.
    </p>
    <section
        *ngIf="ccpAudit"
        style="background-color: yellow"
    >
        <p>
            You have been selected to provide documentation of the CE information you
      entered as part of our random audit process. To complete your
      recertification, you must submit the information below by
      {{ ccpStatus.AuditDue | date : "M/d/yyyy" }}:
        </p>
        <ul>
            <li>
                A copy of the certificate for each CE course you entered. All
        certificates must include your name, date of completion and the number
        of hours awarded.
            </li>
            <li>
                A copy of this notice or the email sent to you.
            </li>
        </ul>
        <p>
            To expedite this process, submit copies of the CE completion certificates
      along with this notice by fax to 913.712.9283 or by email in a single PDF
      file to
            <a href="Service@nbrc.org">Service@nbrc.org</a>
            . We are not able
      to accept screenshots and/or photos of CE completion certificates. To
      review the courses you submitted, log in to the Practitioner Portal at
            <a href="http://NBRC.org">nbrc.org</a>
            and select 'Enter my CEUs.' If you are unable to submit your documentation
      by fax or email, mail your documents to:
        </p>
        <p>
            NBRC
            <br>
            10801 Mastin Street, Suite 300
            <br>
            Overland Park, KS 66210
        </p>
        <p>
            If you have questions regarding this notice, please contact us at
      913.895.4900 or
            <a href="Service@nbrc.org">Service@nbrc.org</a>
            .
        </p>
    </section>

    <app-courses
        *ngIf="ccpStatus.zoneStatus !== 'GREEN'"
        [courses]="courses"
        [ccpAudit]="ccpAudit"
        (courseDeleted)="deleteCourse($event)"
    ></app-courses>
</span>
<h4 *ngIf="
    ccpEligible === false &&
    ccpStatus &&
    ccpStatus.feeOverrideAmount &&
    ccpStatus.feeOverrideAmount > 0
  ">
    <p>
        You can reinstate your credential via an exception that you were granted by
    the NBRC. Click recertify now to enter payment information.
    </p>
    <button
        class="button button--alt--color"
        (click)="recertify = true; performRecertificationTask()"
    >
        Recertify Now
    </button>
</h4>
<h4 *ngIf="ccpEligible === false && ccpStatus && !ccpStatus.feeOverrideAmount">
    You are not required to participate in the Credential Maintenance Program.
</h4>
<p></p>
<ul
    *ngIf="ccpEligible !== false"
    class="list list--bare"
>
    <li class="button-text-combo">
        <a
            href="#"
            routerLink="/"
            class="button button--tertiary button-text-combo__button"
        >
            Go
        </a>
        <span class="button-text-combo__text">
            <strong>Option 2:</strong>
            Pass an NBRC credentialing examination not
      previously completed.
        </span>
    </li>
    <li class="button-text-combo">
        <a
            href="#"
            class="button button--tertiary button-text-combo__button"
        >
            Go
        </a>
        <span class="button-text-combo__text">
            <strong>Option 3:</strong>
            Retake and pass the respective examination for
      the highest credential held that is subject to the CMP.
        </span>
    </li>
</ul>
